import { render, staticRenderFns } from "./Login-tab.vue?vue&type=template&id=6e820e98&scoped=true"
import script from "./Login-tab.vue?vue&type=script&lang=js"
export * from "./Login-tab.vue?vue&type=script&lang=js"
import style0 from "./Login-tab.vue?vue&type=style&index=0&id=6e820e98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e820e98",
  null
  
)

export default component.exports